<template>
  <div class="hero-body is-paddingless" id="wrap-svg">
    <svg ref="sgsh" id="svg-scheme" preserveAspectRatio="xMinYMin meet">
      <g class="svg-pan-zoom_viewport">
        <circle
            v-for="(place) in places"
            :r="place.radius"
            :cx="place.cx"
            :cy="place.cy"
            :style="{fill: place.place.is_cam? 'red' : place.styles.fill, stroke: place.place.is_cam? '#ffffff' : place.styles.stroke, 'stroke-width': place.place.is_cam? '3' : place.styles['stroke-width']}"
            @mousemove="placeHover($event,place.place)"
            @mouseleave="placeUnHover()"
            :stroke-width="inCart(place.place) ? 3 : 0"
            :id="'place'+place.place.id"
            :class="['place', {'selected': inCart(place.place)}, {'closed':!(place.place.is_cam) && (place.place.status!== 2 || place.place.price <= 0)}]"
            @click="placeClick(place.place)"
            v-bind:key="place.place.id"
        >
        </circle>
      </g>
    </svg>
    <div class="control-zoom">
      <button class="control-zoom__button button is-rounded plus" @click="zoomPlus">
                      <span class="icon is-large">
                      <i class="mdi mdi-24px mdi-plus"></i>
                    </span>
      </button>
      <button class="control-zoom__button button is-rounded minus" @click="zoomMinus">
                    <span class="icon is-large">
                      <i class="mdi mdi-24px mdi-minus"></i>
                    </span>
      </button>
    </div>
    <legend-price/>
    <!--      <router-link v-if="mobile" class="button is-info is-rounded has-text-weight-bold button-back"-->
    <!--                   tag="a"-->
    <!--                   :to="'/sections'">-->
    <b-button type="is-info"
              class="is-rounded has-text-weight-bold button-back"
              @click="goToSectionList()"
              v-if="eventCard.is_navigated && mobile">
      <i class="mdi mdi-24px mdi-undo"></i> К секциям
    </b-button>
    <!--      </router-link>-->
  </div>

</template>
<script>
const OnSale = 2;
// import Seat from './Seat';
import LegendPrice from './LegendPrice';

import {svgMixin} from "../mixins/svgMixin";
import {mapGetters, mapState} from "vuex";

export default {
  name: "Section",
  mixins: [svgMixin],
  components: {
    // 'seat': Seat,
    LegendPrice
  },
  data() {
    return {
      sectionID: this.$route.params.section_id,
      selections: {},
      loaded: false,
      showNumber: false,
      places: [],
    }
  },
  computed: {
    ...mapState({
      hallPlan: state => state.hallPlan,
      mobile: state => state.mobile,
      performanceID: state => state.performanceID,
      eventCard: state => state.eventCard,
      legendSelected: state => state.legendSelected,
      ticketsCart: state => state.cart.items,
    }),
    ...mapGetters('cart', {
      // cartTotalPrice: 'cartTotalPrice',
      cartCountTickets: 'cartCountTickets'
    }),
    elementsCount() {
      return this.$refs.sgsh.children[0].children.length
    }

  },
  methods: {
    inCart: function (place) {
      let indexInCart = this.ticketsCart.findIndex(item => item.id === place.id);
      return indexInCart !== -1;
    },
    placeHover(event, place) {
      // Если место имеет статус "В продаже"

      if (place.status === OnSale && place.price > 0) {
        this.showNumber = true;
        let seatInfo = {
          description: place.description,
          // section: this.place.sectionName,
          price: place.price,
          row: place.row,
          number: place.place,
          position: {
            left: event.pageX + "px",
            top: event.pageY + "px"
          }
        };
        this.$events.fire('showTooltip', seatInfo);
      }
      if (place.is_cam) {
        let seatInfo = {
          is_cam: place.is_cam,
          position: {
            left: event.pageX + "px",
            top: event.pageY + "px"
          }
        }
        this.$events.fire('showTooltip', seatInfo);
      }
    },
    placeUnHover() {
      this.showNumber = false;
      this.$events.fire('hideTooltip');
    },
    placeClick(place) {
      if (place.status === OnSale && place.price > 0) {
        switch (this.inCart(place)) {
          case false:
            if (this.cartCountTickets >= 9) {
              // Проверяем, чтобы в корзине небыло больше 9 билетов
              this.$events.fire('maxTickets');
            } else {
              this.showNumber = true;
              this.$store.dispatch('cart/addTicketToCart', place);
            }
            break;

          case true:
            this.showNumber = false;
            this.$store.dispatch('cart/removeTicketFromCart', place.id);
            break;

          default:

            break;
        }
      }
    },
    async getSectionTickets() {
      await window.api.getPerformanceTickets(this.performanceID, this.sectionID ? this.sectionID : undefined)
          .then(response => {
            if (response.data.data && response.data.data.length > 0) {
              this.places = response.data.data.map((p) => {
                return {
                  place: p,
                  cx: p.x + 17.5 + 7,
                  cy: p.y + 17.5 + 7,
                  radius: 17.5,
                  styles: {
                    'fill': p.color,
                    'fill-opacity': 1,
                  }
                }
              });
              this.loaded = true
            } else {
              if ((this.eventCard.is_navigated && this.mobile) || !this.mobile) {
                this.$router.push({name: 'Sections'})
              } else {
                this.$router.push({name: 'Error'})
              }
            }
          })
          .catch(e => {
            console.log(e);
            this.$buefy.snackbar.open({
              duration: 5000,
              message: e.response.data.message,
              type: 'is-danger',
              position: 'is-bottom-left',
              queue: false,
            })
            this.$router.push({name: 'Error'});
          });
    },
    goToSectionList() {

      this.$events.fire('showLoader');
      setTimeout(() => {
        this.$router.push({name: 'Sections'}).catch(err => {
          // Ignore the vuex err regarding  navigating to the page they are already on.
          if (
              err.name !== 'NavigationDuplicated' &&
              !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            console.log(err);
          }
        });
      }, 500);
    },
  },
  async created() {
    this.$events.fire('showLoader');
    await this.getSectionTickets();
    this.$nextTick(function () {
      // $nextTick - важно для проверки момента, когда отрисована вся схема
      // Send the event on a channel (endRenderSeats)
      this.$events.fire('endRenderSeats');

    })
  },
  mounted() {
    this.setHeaderSVG('svg-scheme');
  },
  events: {
    endRenderSeats() {
      this.initPanZoom('svg-scheme');
    },
    legendSelectedEvent(price) {
      let vm = this
      this.places.forEach((p) => {
        if (!vm.legendSelected || price === 0) {
          p.radius = 17.5
          p.styles["fill-opacity"] = 1
        } else if (p.place.price === price && (p.place.status === OnSale && p.place.price > 0)) {
          p.radius = 20
          p.styles["fill-opacity"] = 1
        } else {
          p.radius = 17.5
          p.styles["fill-opacity"] = "0.25"
        }
      })
    }
  }
}

</script>

<style scoped lang="scss">

svg {
  width: 100%;
  // Анимация довольно спорная при pan
  /*.svg-pan-zoom_viewport {*/
  /*    transition: transform 0.2s ease-out;*/
  /*}*/
}

.hero {
  &-body {
    height: 100%;
    flex: 1;
    position: relative;
    align-items: normal !important;

    .button-back {
      position: absolute;
      left: 0;
      bottom: 0;
      text-transform: lowercase;
    }
  }
}
</style>
